import React from 'react';
import ImageV2 from 'components_v2/common/ImageV2';
import s from './UsStateBattle.scss';
import { IMAGE_URL } from '../../../../constants';

const UsStateBattle = ({ stateName, electTotal, starCandidates, eevp }) => (
  <section className={`${s.usStateBattleWrap}`}>
    <div className={s.stateName}>
      <span>{stateName}</span>
      <span className={s.eevp}>{eevp}% of votes counted</span>
    </div>
    <div className={s.usbTable}>
      <div className={`${s.usbRow} ${s.flex}`}>
        <div className={`${s.clo1} ${s.col}`}>{electTotal} electoral votes</div>
        <div className={`${s.clo2} ${s.col}`}>Votes</div>
        <div className={`${s.clo3} ${s.col}`}>Pct %</div>
        <div className={`${s.clo4} ${s.col}`}>E.V.</div>
      </div>
      {/* Loop below */}
      <div
        className={`${s.usbRow} ${s.usbRowBold} ${s.flex} ${
          starCandidates?.Donald?.winner === 'X' ? s.active : ''
        }`}
        style={
          starCandidates?.Donald?.winner === 'X'
            ? { background: starCandidates?.Donald?.partyColor }
            : {}
        }
      >
        <div className={`${s.clo1} ${s.col} ${s.flex}`}>
          <div
            className={s.partySymb}
            style={{ borderColor: starCandidates?.Donald?.partyColor }}
          >
            <ImageV2
              src={`${IMAGE_URL}${starCandidates?.Donald?.partyLogo}.cms`}
              alt=""
            />
          </div>
          <span>
            {starCandidates?.Donald?.first} {starCandidates?.Donald?.last}
          </span>
        </div>
        <div className={`${s.clo2} ${s.col}`}>
          {!isNaN(starCandidates?.Donald?.voteCount)
            ? starCandidates?.Donald?.voteCount.toLocaleString()
            : 0}
        </div>
        <div className={`${s.clo3} ${s.col}`}>
          {starCandidates?.Donald?.votePercentage || 0}%
        </div>
        <div className={`${s.clo4} ${s.col}`}>
          {starCandidates?.Donald?.electWon || 0}
        </div>
      </div>

      <div
        className={`${s.usbRow} ${s.usbRowBold} ${s.flex} ${
          starCandidates?.Kamala?.winner === 'X' ? s.active : ''
        }`}
        style={
          starCandidates?.Kamala?.winner === 'X'
            ? { background: starCandidates?.Kamala?.partyColor }
            : {}
        }
      >
        <div className={`${s.clo1} ${s.col} ${s.flex}`}>
          <div
            className={s.partySymb}
            style={{ borderColor: starCandidates?.Kamala?.partyColor }}
          >
            <ImageV2
              src={`${IMAGE_URL}${starCandidates?.Kamala?.partyLogo}.cms`}
              alt=""
            />
          </div>
          <span>
            {starCandidates?.Kamala?.first} {starCandidates?.Kamala?.last}
          </span>
        </div>
        <div className={`${s.clo2} ${s.col}`}>
          {!isNaN(starCandidates?.Kamala?.voteCount)
            ? starCandidates?.Kamala?.voteCount.toLocaleString()
            : 0}
        </div>
        <div className={`${s.clo3} ${s.col}`}>
          {starCandidates?.Kamala?.votePercentage || 0}%
        </div>
        <div className={`${s.clo4} ${s.col}`}>
          {starCandidates?.Kamala?.electWon || 0}
        </div>
      </div>
    </div>
  </section>
);

// UsStateBattle.propTypes = {

// };
// UsStateBattle.defaultProps = {

// };

export default UsStateBattle;
